module.exports = new __parcel__URL__("gitlab-logomark.dd8db60b.svg").toString();